export const loadResource = (key: string, path: string) => {
  return new Promise((resolve, reject) => {
    if (typeof window === "undefined") {
      return reject("SSR: No window object");
    }

    const Window = window as any;

    if (Window[key]) {
      return resolve(Window[key]);
    }

    const script = document.createElement("script");
    document.body.appendChild(script);
    script.onload = () => {
      resolve(Window[key]);
    };
    script.onerror = reject;
    script.async = true;
    script.src = path;
  });
};

const externalLibraries = (() => {
  const AdobeDC = () => {
    const AdobeDCSrc = "https://documentcloud.adobe.com/view-sdk/viewer.js";
    const Window = window as any;

    if (typeof Window["AdobeDC"] === "undefined") {
      return new Promise((resolve, reject) => {
        loadResource("AdobeDC", AdobeDCSrc)
          .then(() => {
            document.addEventListener("adobe_dc_view_sdk.ready", () => {
              if (Window["AdobeDC"]) {
                resolve(Window["AdobeDC"]);
              } else {
                reject("AdobeDC is not ready properly");
              }
            });
          })
          .catch(reject);
      });
    } else {
      return loadResource("AdobeDC", AdobeDCSrc);
    }
  };

  return {
    AdobeDC,
  };
})();

export default externalLibraries;
